import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { SIPExtensions } from './components';

const routes = () => (
  <PrivateRoute
    exact
    path="/settings/SIPExtensions"
    component={SIPExtensions}
  />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/SIPExtensions/routes.js